import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  CustomerModel,
  CustomerMutationInput,
  CustomerDeleteInput,
  CustomerUpdateInput,
  CustomerSimilarDataModel,
} from './model';

export function useCreateCustomer(
  options?: UseMutationOptions<
    ApiResult<CustomerModel>,
    ApiError,
    CustomerMutationInput
  >,
): UseMutationResult<
  ApiResult<CustomerModel>,
  ApiError,
  CustomerMutationInput
> {
  return useMutation<ApiResult<CustomerModel>, ApiError, CustomerMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'customers',
        method: 'POST',
        classType: CustomerModel,
        body,
      });
    },
    options,
  );
}

export function useCheckCustomerSimilarData(
  options?: UseMutationOptions<any, ApiError, CustomerMutationInput>,
): UseMutationResult<any, ApiError, CustomerMutationInput> {
  return useMutation<any, ApiError, CustomerMutationInput>(async function (
    body,
  ) {
    return await MutationFetchFunction({
      url: 'customers/check-similar-data',
      method: 'POST',
      body,
    });
  },
  options);
}

export function useUpdateCustomer(
  options?: UseMutationOptions<
    ApiResult<CustomerModel>,
    ApiError,
    CustomerUpdateInput
  >,
): UseMutationResult<ApiResult<CustomerModel>, ApiError, CustomerUpdateInput> {
  return useMutation<ApiResult<CustomerModel>, ApiError, CustomerUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `customers/${body.customerId}`,
        method: 'PUT',
        classType: CustomerModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteCustomer(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CustomerDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, CustomerDeleteInput> {
  return useMutation<{ message: string }, ApiError, CustomerDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `customers/${body.customerId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}

export function useSuspendCustomer(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CustomerDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, CustomerDeleteInput> {
  return useMutation<{ message: string }, ApiError, CustomerDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `customers/${body.customerId}/surveillance`,
        method: 'PATCH',
        body: body.body,
      });
    },
    options,
  );
}
